import { Component, OnDestroy } from '@angular/core';
import { StudentService } from '../student/student.service';
import { StudentInfoPortalComponent } from './student-info-portal/student-info-portal.component';
import { UserService } from '../user/user.service';
import { Portal } from '../portal.model';
import { Classroom360Service } from '../../classroom360/classroom360.service';
import { MealServiceService } from '../../student360/meal-service/meal-service.service';
import { Subscription } from 'rxjs';
import { MyReportsComponent } from '../../shared-modules/reporting/my-reports/my-reports.component';
import { ReportingService } from '../../shared-modules/reporting/reporting.service';
import { ReportingComponent } from '../../shared-modules/reporting/reporting.component';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { YearService } from '../year/year.service';
import { LoginService } from '../../shared-modules/login/login.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-student-information',
    templateUrl: './student-information.component.html'
})

export class StudentInformationComponent implements OnDestroy {

    student: any;
    students: any = [];
    staffPortals: Portal[];
    portalDialog: MatDialogRef<StudentInfoPortalComponent>;
    studentViewRouteSubscription: Subscription;
    selectedStudentSubscription: Subscription;
    myReportsDialogRef: MatDialogRef<MyReportsComponent>;
    portalName = '';

    constructor(
        private dialogRef: MatDialogRef<StudentInformationComponent>,
        private dialog: MatDialog,
        private studentService: StudentService,
        private classroom360Service: Classroom360Service,
        private userService: UserService,
        private mealServiceService: MealServiceService,
        private reportService: ReportingService,
        private yearService: YearService,
        private loginService: LoginService

    ) {
        this.studentViewRouteSubscription = this.userService.observableStudentInfoRouteStream$.subscribe((route) => {
            const portal = this.staffPortals.filter(p => p.PortalDescription == route.replace('/student360', ''))[0];
            if (portal != undefined || route.indexOf('sendEmail') > -1) {
                if (route.indexOf('sendEmail') > -1) {
                    this.portalClick('Send Email');
                }
                else {
                    this.portalClick(portal.PortalName);
                }
            }
        });

        this.selectedStudentSubscription = this.studentService.selectedStudentStream$.subscribe(studentId => {
            if (this.portalName != '') {
                if (studentId > 0) {
                    this.portalClick(this.portalName);
                    this.selectedStudentSubscription.unsubscribe();
                }
            }
        });
    }

    ngOnDestroy() { }

    initMenu() {
        this.userService.studentInformationView = true;
        this.studentService.getStudent(this.student.Id).subscribe(student => {
            const studentIndex = this.students.findIndex(x => x.Id == student.Id);
            this.studentService.updateStudents(this.students, studentIndex);
            if (this.portalName == '') {
                this.getStaffPortals();
            }
        });
    }

    portalClick(portalName: string) {
        this.userService.selectedStudentInfoPortal = portalName;

        // My Reports
        if (portalName == 'My Reports') {
            this.reportService.isReportsMenu = true;

            const dialogBox = this.dialog.open(ReportingComponent, {
                disableClose: true,
                // hasBackdrop: false,
                // panelClass: 'disableModalStyle'
            });
            const subscription = dialogBox.afterClosed().subscribe(course => {
                subscription.unsubscribe();
                return;
            });
        }
        else {
            this.studentService.getStudent((this.studentService.selectedStudent && this.studentService.selectedStudent.Id) ? (this.studentService.selectedStudent.Id) : (this.student.Id)).subscribe(student => {
                if (!this.studentService.selectedStudent) {
                    this.studentService.selectedStudent = this.student;
                }
                this.studentService.selectedStudent.Picture = student.Picture;
            });
            this.portalDialog = this.dialog.open(StudentInfoPortalComponent, {
                panelClass: 'tyl-mat-dialog', width: '100%', minWidth: '100%', height: '100%', disableClose: true
            });
            if (portalName == 'Monthly Lunch Menu') {
                this.mealServiceService.selectionIndex = 1;
            }
            if (portalName == 'Meal Service') {
                this.mealServiceService.selectionIndex = 0;
            }
            if (portalName == 'Programs and Services') {
                this.userService.getUserPermissions(
                    this.yearService.defaultYear.Id,
                    this.yearService.defaultYear.SchoolID
                ).subscribe(permissions => {
                    const userPermissions = permissions;
                    // Determining if the user can edit program
                    const hasPSPermission = userPermissions.find(permission => permission.PermissionName == 'Maintain ALL Student Programs and Services' || permission.PermissionName == 'View ALL Student Programs and Services');
                    if (this.loginService.LoginSettings.ActivateProgramAndService360 && hasPSPermission) {
                        this.portalDialog.componentInstance.hasProgramAndServicePermission = true;
                    } else {
                        this.portalDialog.componentInstance.hasProgramAndServicePermission = false;
                    }
                    this.portalDialog.componentInstance.showPortal(portalName);
                });
            }
            else {
                this.portalDialog.componentInstance.showPortal(portalName);
            }

            this.portalDialog.afterClosed().subscribe(() => {
                this.student = this.studentService.selectedStudent;
                if (this.portalName != '') {
                    this.closeClick();
                }
            });
        } // end if My Reports
    }

    getStaffPortals() {
        this.classroom360Service.getStaffAssignedPortals().subscribe(data => {
            this.staffPortals = data.filter(portal => (portal.ParentModule == '/student360' || portal.PortalName == 'Send Email' || (portal.PortalName == 'Student Notes' && portal.GroupName != 'Tools')) && portal.ShowAsMenu && portal.PortalName != 'Student Summary' && portal.PortalDescription != '/eFormsStaff/:staffPage' && portal.PortalDescription != '/scheduleHistory/multipleStudent');
        });
    }

    closeClick() {
        this.userService.selectedStudentInfoPortal = undefined;
        this.userService.studentInformationView = false;
        this.dialogRef.close();
    }
}
